import { FormType } from '../keys';

export const FIELDS_SUPPORTING_PARTIAL_UPDATE: (keyof FormType)[] = [
  'registeredAddress',
  'physicalAddress',
  'accountPurpose',
  'accountPurposeOther',
  'expectedMonthlyPaymentsUsd',
  'estimatedAnnualRevenueUsd',
  'hasMaterialIntermediaryOwnership',
  'sourceOfFunds',
  'sourceOfFundsDescription',
  'operatesInProhibitedCountries',
  'isHighRiskActivities',
  'highRiskActivities',
  'documents',
];

export const isFieldDisabledInPartialMode = (fieldPath: string, isPartialMode: boolean): boolean => {
  if (!isPartialMode) return false;

  if (fieldPath.includes('associatedPersons') && fieldPath.includes('documents')) {
    return true;
  }

  const isSupported = FIELDS_SUPPORTING_PARTIAL_UPDATE.some((field) => fieldPath.startsWith(field));

  return !isSupported;
};
